export type NavItem = {
  label: string;
  path: string;
  icon: string;
};

export type NavSection = {
  title: string;
  items: NavItem[];
};

type FeatureFlags = {
  showCPGRates: boolean;
  showCrossRampRates: boolean;
  showAnalytics: boolean;
  showDownloadReport: boolean;
};

export const buildNavSections = (flags: FeatureFlags): NavSection[] => {
  const sections: NavSection[] = [
    {
      title: "Orders",
      items: [
        { label: "X Ramp", path: "/", icon: "currency_exchange" },
        { label: "CPG", path: "/cpg", icon: "payments" },
      ],
    },
    {
      title: "Rates",
      items: [
        flags.showCPGRates
          ? { label: "CPG rates", path: "/cpg-rates", icon: "price_change" }
          : null,
        flags.showCrossRampRates
          ? {
              label: "X Ramp rates",
              path: "/cross-ramp-rates",
              icon: "trending_up",
            }
          : null,
      ].filter((item): item is NavItem => item !== null),
    },
    {
      title: "Insights",
      items: [
        flags.showAnalytics
          ? { label: "Analytics", path: "/analytics", icon: "monitoring" }
          : null,
        flags.showDownloadReport
          ? { label: "Reports", path: "/download-report", icon: "download" }
          : null,
      ].filter((item): item is NavItem => item !== null),
    },
  ];

  return sections.filter((section) => section.items.length > 0);
};
